import { mapGetters } from 'vuex';
import ProcessNavigation from '@/components/process-navigation/index.vue';

export default {
  components: {
    ProcessNavigation
  },
  data() {
    return {
      processList: ['验证身份', '重置密码', '重置成功'],
      step: 3
    };
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  created() {
  },
  mounted() {
    // this.form.mobile = this.userInfo && this.userInfo.mobile || '1';
  },
  methods: {
    resetLogin() {
      this.$router.push('/signin');
    }
  }
};
